import { m } from "@recobra/i18n/messages";
import type { Task, TaskHistoryEntry } from "@recobra/schemas/task";

export const taskContextIdentifier = (
  task: Pick<Task, "contextType" | "contextId" | "contextCaseNumber">,
): string => {
  if (task.contextType !== "case") return task.contextId.slice(-8);

  return task.contextCaseNumber == null ? m.common_em_dash() : `#${task.contextCaseNumber}`;
};

/** Renders a date-only ISO value without letting the UTC parse shift it a day back. */
export const formatTaskDate = (date: string): string =>
  new Date(`${date}T00:00:00`).toLocaleDateString("pt-BR");

/** Renders a full ISO timestamp as its calendar date. */
export const formatTaskTimestamp = (timestamp: string): string =>
  new Date(timestamp).toLocaleDateString("pt-BR");

/**
 * The history entry recorded when the task was executed, if the caller can see task history.
 * `task.history` is stripped entirely for callers outside internalStaff visibility.
 */
export const findTaskExecutionEntry = (task: Task): TaskHistoryEntry | undefined =>
  task.history?.findLast((entry) => entry.action === "execute");
